import { getFirebaseIDToken } from "../firebase/firebase";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Maak een zending aan vanuit een order
 * @param {Object} order - Het volledige order object
 * @returns {Promise<Object>} - De aangemaakte zending
 */
export const createShipmentFromOrder = async (order) => {
  const idToken = await getFirebaseIDToken();

  const response = await fetch(`${API_URL}/api/svz/shipments/from-order`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: idToken,
    },
    body: JSON.stringify(order),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || "Failed to create shipment");
  }

  return response.json();
};

/**
 * Haal een specifieke zending op
 * @param {String} shipmentId - Het zending ID
 * @returns {Promise<Object>} - De zending data
 */
export const getShipment = async (shipmentId) => {
  const idToken = await getFirebaseIDToken();

  const response = await fetch(`${API_URL}/api/svz/shipments/${shipmentId}`, {
    method: "GET",
    headers: {
      Authorization: idToken,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || "Failed to fetch shipment");
  }

  return response.json();
};

/**
 * Wijzig een zending
 * @param {String} shipmentId - Het zending ID
 * @param {Object} data - De te wijzigen data
 * @returns {Promise<Object>} - De gewijzigde zending
 */
export const updateShipment = async (shipmentId, data) => {
  const idToken = await getFirebaseIDToken();

  const response = await fetch(`${API_URL}/api/svz/shipments/${shipmentId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: idToken,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || "Failed to update shipment");
  }

  return response.json();
};

/**
 * Annuleer een zending
 * @param {String} shipmentId - Het zending ID
 * @returns {Promise<Object>} - De geannuleerde zending
 */
export const cancelShipment = async (shipmentId) => {
  const idToken = await getFirebaseIDToken();

  const response = await fetch(`${API_URL}/api/svz/shipments/${shipmentId}/cancel`, {
    method: "POST",
    headers: {
      Authorization: idToken,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || "Failed to cancel shipment");
  }

  return response.json();
};

/**
 * Helper functie om error messages gebruiksvriendelijk te maken
 * @param {Error} error - De error
 * @returns {String} - Gebruiksvriendelijke foutmelding
 */
export const getShipmentErrorMessage = (error) => {
  const message = error.message || "";

  if (message.includes("not found")) {
    return "Zending niet gevonden.";
  }
  if (message.includes("400") || message.includes("Invalid")) {
    return "Ongeldige gegevens. Controleer het formulier.";
  }
  if (message.includes("401") || message.includes("Unauthorized")) {
    return "Niet geautoriseerd. Log opnieuw in.";
  }
  if (message.includes("404")) {
    return "Zending niet gevonden.";
  }
  if (message.includes("502") || message.includes("Bad Gateway")) {
    return "Fout bij communicatie met transporteur. Probeer later opnieuw.";
  }
  if (message.includes("500")) {
    return "Er is iets misgegaan. Neem contact op met support.";
  }

  return message || "Er is een onbekende fout opgetreden.";
};
